module.exports = __webpack_public_path__ + "img/fe_backdrop_emblem_emperor.1e91205e.png";